import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from "react-bootstrap";
import {
  renderTableWorklogColumns,
  renderTableWorklogRows,
} from "../dashboard-util/dashboard-utils";
import DynamicFieldBulk from "../../../components/DynamicFieldBulk/DynamicFieldBulk";
import "./dashboard-real-estate.scss";
import "../../tasks/scenes/tasks-comments/shared-modal-header.scss";

const WorklogModal = ({
  isAllRbc,
  isStaffer,
  currentUserId,
  selectedMember,
  showState,
  onHideFunction,
  fetchData,
}) => {
  const hasWorklogTracker = selectedMember?.WorklogTracker && selectedMember?.WorklogTracker.length > 0;

  const itemId = hasWorklogTracker
    ? selectedMember?.WorklogTracker[0]?.ProjectId
    : null;

  const itemName = hasWorklogTracker
    ? selectedMember?.WorklogTracker[0]?.ProjectName
    : "";

  const keyRight = selectedMember.UserId ?? 0;
  const keyLeft  = selectedMember?.WorklogTracker[0]?.ProjectId ?? 0;
  const keyMiddle = itemId ?? 0;

  const key = `${keyLeft}-${keyMiddle}-${keyRight}-${itemName}`;

  return (
    selectedMember && (
      <Modal
        key={key}
        show={showState}
        onHide={onHideFunction}
        contentClassName="deal-and-vacation-date-real-estate-modal-styles"
        dialogClassName="deal-and-vacation-date-real-estate-modal"
        backdropClassName="real-estate-modal-backdrop"
        scrollable={true}
      >
        <div className="popup-week real-estate-deal">
          <Modal.Header className="header-popup" closeButton>
            <div className="real-estate-deal-task-name">
              <div className="real-estate-deal-user-name">
                {selectedMember.Name}
              </div>
            </div>
          </Modal.Header>
          <hr></hr>
          <Modal.Body className="header-body">
            { isStaffer || selectedMember.UserId !== currentUserId ?
                <div className="real-estate-table-container">
                  <div className={`${true ? "table-wrapper" : ""}`}>
                    <table className="real-estate-modal-table tableSticky">
                      { selectedMember.WorklogTracker.map((worklog, index) => (
                        <React.Fragment key={worklog.ProjectId}>
                          { index === 0 &&
                            <React.Fragment key={`col-${key}`}>
                              {renderTableWorklogColumns(worklog.TableWorklog[0].Columns)}
                            </React.Fragment>
                          }
                          { worklog.TableWorklog.map((tableWorklog, rowIndex) =>
                            <React.Fragment key={`row-${rowIndex}`}>
                              {renderTableWorklogRows(tableWorklog.Rows, tableWorklog.Columns)}
                            </React.Fragment>
                            )
                          }
                        </React.Fragment>
                      ))}
                    </table>
                  </div>
                </div>
              :
                <DynamicFieldBulk
                  objectType={"TaskComment"}
                  objectId={0}
                  taskTypeId={selectedMember.WorklogTracker[0].TaskTypeId}
                  projectTypeId={selectedMember.WorklogTracker[0].ProjectTypeId} //TemplateId
                  columnNamesNotNeeded={[]}
                  fetchData={fetchData}
                  hasProjectColumn={true}
                  hasMemberColumn={true}
                  hasDueDate={false}
                  widgetName={"RealEstate"}
                  selectedMember={selectedMember}
                />
            }
          </Modal.Body>
        </div>
      </Modal>
    )
  );
};

const ColumnPropType = PropTypes.shape({
  Id: PropTypes.number.isRequired,
  Name: PropTypes.string.isRequired,
  Type: PropTypes.string.isRequired,
  Order: PropTypes.number.isRequired,
  LookupValues: PropTypes.string,
  LockStatus: PropTypes.number.isRequired,
});

const DataPropType = PropTypes.shape({
  Id: PropTypes.number.isRequired,
  ColumnId: PropTypes.number.isRequired,
  ColumnType: PropTypes.string,
  ColumnName: PropTypes.string,
  Value: PropTypes.string,
  LookupValues: PropTypes.string,
  ColumnLockStatus: PropTypes.number,
});

const RowPropType = PropTypes.shape({
  Id: PropTypes.number.isRequired,
  Row: PropTypes.number.isRequired,
  Data: PropTypes.arrayOf(DataPropType),
});

const TablePropType = PropTypes.shape({
  Columns: PropTypes.arrayOf(ColumnPropType),
  Rows: PropTypes.arrayOf(RowPropType),
});

WorklogModal.propTypes = {
  isAllRbc: PropTypes.bool.isRequired,
  isStaffer: PropTypes.bool.isRequired,
  currentUserId: PropTypes.number.isRequired,
  selectedMember: PropTypes.shape({
    CompanyId: PropTypes.number.isRequired,
    CompanyName: PropTypes.string.isRequired,
    UserId: PropTypes.number.isRequired,
    Name: PropTypes.string.isRequired,
    Type: PropTypes.string,
    TypeColor: PropTypes.string,
    ActiveDeals: PropTypes.number,
    LastUpdated: PropTypes.string,
    HoursThisWeek: PropTypes.number,
    WorkingWeekend: PropTypes.bool,
    HoursNextWeek: PropTypes.number,
    Comments: PropTypes.string,
    WorklogTracker: PropTypes.arrayOf(PropTypes.shape({
      TaskId: PropTypes.number.isRequired,
      TaskName: PropTypes.string.isRequired,
      ProjectId: PropTypes.number.isRequired,
      ProjectName: PropTypes.string,
      OwnerUserId: PropTypes.number,
      OwnerUserName: PropTypes.string,
      EditorUserId: PropTypes.number.isRequired,
      EditorUserName: PropTypes.string,
      Type: PropTypes.string,
      TypeColor: PropTypes.string,
      TaskTypeId: PropTypes.number,
      ProjectTypeId: PropTypes.number,
      LastUpdated: PropTypes.string,
      CreationTime: PropTypes.string,
      CreationTimeString: PropTypes.string,
      WeekString: PropTypes.string,
      HoursThisWeek: PropTypes.number,
      WorkingWeekend: PropTypes.bool,
      HoursNextWeek: PropTypes.number,
      Comments: PropTypes.string,
      AllowWorklogEdit: PropTypes.bool.isRequired,
      TableWorklog: PropTypes.arrayOf(TablePropType)
    })),
  }).isRequired,
  showState: PropTypes.bool.isRequired,
  onHideFunction: PropTypes.func,
  fetchData: PropTypes.func,
};

export default WorklogModal;
